import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import * as React from 'react';

const Copyright: React.FC = () => {
    return (
        <Box
            sx={{
                py: 4,
                borderTop: '1px solid rgba(255,255,255,0.08)',
                textAlign: 'center',
            }}
        >
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {'Copyright © '}
                <Link color="inherit" href="https://framedghosts.com/">
                    Framed Ghosts
                </Link>{' '}
                {new Date().getFullYear()}.
            </Typography>
        </Box>
    );
};

export default Copyright;
